import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="inline-block cursor-pointer">
                <span className="text-lg font-heading font-bold text-foreground-900">
                  91蜜桃
                </span>
              </Link>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                91蜜桃官方导航网站，为您提供最新入口地址、使用教程及常见问题解答。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/category/latest-links"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    最新入口
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/usage-guide"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    使用教程
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/faq"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    常见问题
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                联系我们
              </h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-mail-line text-primary-500"></i>
                  support@91mitao.com
                </li>
                <li className="text-sm text-foreground-600">
                  服务时间：周一至周日 9:00-21:00
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 91蜜桃官方导航. 保留所有权利.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
                使用条款
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}